import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'

function PasswordField(props) {
  const [field, setField] = useState('')
  const [field_touched, setFieldTouched] = useState(false)

  const validate = (e) => {
    e.preventDefault()

    const elem = document.getElementById(props.id)
    if (elem.value) {
      setField(elem.value)
      props.setField(elem.value)
    } else {
      setField(undefined)
      props.setField(undefined)
    }
  }

  return (
    <Col xs={props.xs} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl}>
      <Form.Group>
        <Form.Label>{props.label}</Form.Label>
        <Form.Control
          id={props.id}
          type="password"
          placeholder=""
          minLength="8"
          maxLength="50"
          onInput={validate}
          onBlur={() => {
            setFieldTouched(true)
            props.setFieldTouched && props.setFieldTouched(true)
          }}
          isInvalid={field_touched && (!field || (field && field.length < 8))}
        />
        <Form.Control.Feedback type="invalid">
          {props.invalid_message}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

PasswordField.propTypes = {
  id: PropTypes.string.isRequired,
  invalid_message: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  lg: PropTypes.number,
  md: PropTypes.number,
  setField: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func,
  sm: PropTypes.number,
  xl: PropTypes.number,
  xs: PropTypes.number
}

export default PasswordField
